import { render } from "./Devolver.vue?vue&type=template&id=1393aee8"
import script from "./Devolver.vue?vue&type=script&lang=js"
export * from "./Devolver.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__